module.exports = __webpack_public_path__ + "2b71fb4198f8bb58849cd1b166db1ba9.png";